// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"3be8016f9ccdc974","777":"190fd9a31416fcb1"}[chunkId] + ".js";
};